import React, { useState } from 'react';

import { getRules, updateRule } from '../../api/rule';
import { useRuleContext } from '../../context/RuleStore';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Animated rainbow background box for edit modal
const RainbowEditBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: 'linear-gradient(-45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #fab1a0, #fd79a8, #a29bfe)',
  backgroundSize: '400% 400%',
  animation: 'rainbowEdit 5s ease infinite',
  border: '20px ridge #000',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  borderRadius: '10%',
  p: 4,
  
  '@keyframes rainbowEdit': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  },
  
  // Style text for better contrast
  '& .MuiTypography-root': {
    color: 'white',
    fontWeight: 'bold',
    textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
  },
  
  // Style text fields for better visibility
  '& .MuiTextField-root': {
    '& .MuiInputLabel-root': {
      color: 'white',
      fontWeight: 'bold',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
      '& input': {
        color: 'white',
        fontWeight: 'bold',
      },
    },
    '& .MuiFormHelperText-root': {
      color: 'white',
      fontWeight: 'bold',
    },
  }
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '20px ridge #000',
  boxShadow: 24,
  borderRadius: '10%',
  p: 4,
};

export const EditRuleModal = (props) => {
  const { name, points, margin, description, id, onRuleEdited } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [changeName, setChangeName] = useState(name);
  const [changePoints, setChangePoints] = useState(points);
    const [changeMargin, setChangeMargin] = useState(margin);
  const [changeDescription, setChangeDescription] = useState(description);
  const { state: ruleState, action: ruleActions } = useRuleContext();
  const handleChangeName = (event) => {
    setChangeName(event.target.value);
  };
  const handleChangePoints = (event) => {
    setChangePoints(event.target.value);
  };
    const handleChangeMargin = (event) => {
    setChangeMargin(event.target.value);
  };
  const handleChangeDescription = (event) => {
    setChangeDescription(event.target.value);
  };
  const handleSubmit = async () => {
    // Validation checks
    if (changeName.length > 30) {
      alert('Rule name must be less than 30 characters');
      return;
    }
    
    const pointsValue = parseInt(changePoints);
    if (Math.abs(pointsValue) >= 1000) {
      alert('Points must be less than 1000 (positive or negative)');
      return;
    }
    
    await updateRule({ id, name: changeName, points: changePoints, margin:changeMargin, description: changeDescription });
    handleClose();
    ruleActions.getRulesAsyncAction();
    
    // Show notification if callback provided
    if (onRuleEdited) {
      onRuleEdited();
    }
  };
  return (
    <div>
            <IconButton aria-label="edit" onClick={handleOpen}>
      <EditIcon  style={{display:'flex'}} />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RainbowEditBox>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit Rule
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Edit '{name}'
          </Typography>
          <TextField
            id="outlined-required"
            onChange={handleChangeName}
            label="Name"
            variant="outlined"
            value={changeName}
            inputProps={{ maxLength: 30 }}
            helperText="Maximum 30 characters"
          />
          <TextField
            id="outlined-required"
            onChange={handleChangePoints}
            label="Points"
            variant="outlined"
            value={changePoints}
            type="number"
            inputProps={{ min: -999, max: 999 }}
            helperText="Must be between -999 and 999"
          />
                    <TextField
            id="outlined-required"
            onChange={handleChangeMargin}
            label="Margin"
            variant="outlined"
            value={changeMargin}
            type="number"
            inputProps={{ min: -999, max: 999 }}
            helperText="Must be between -999 and 999"
          />
          <TextField
            id="outlined"
            onChange={handleChangeDescription}
            label="Description"
            variant="outlined"
            value={changeDescription}
          />
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </RainbowEditBox>
      </Modal>
    </div>
  );
};
